import Switch from '@material-ui/core/Switch';
import {
  FormControlLabel,
} from "@mui/material";
import { ReactComponent as RemoveIcon } from "assets/icons/remove-circle.svg";
import { LabelField } from 'components/LabelField';
import Selection from 'components/Selection/Selection';
import React from 'react';
import { AddGroupMembersContainer, AddGroupMembersLabel, AddNewBtn, ContactField, ContactWrapper, MemberCard, MemberItem, MemberRemove, MembersList, MemberSwitch } from "../Theme";




const AddGroupMembers = ({ formik, contactsList, contactSelectedHandler,deleteSelectedContact,contactsLoading,alertSelectedContact }) => {
  return (
    <AddGroupMembersContainer>
      <AddGroupMembersLabel className="d-flex align-items-center justify-content-between mt-2">
        <LabelField
          title={"Members"}
          style={{
            fontSize: "12px",
          }}
        />
        <LabelField
          title={"Alerts"}
          style={{
            fontSize: "12px",
          }}
        />
      </AddGroupMembersLabel>
      <MembersList>
        {formik.values?.contacts?.map((contact, index) => (
          <MemberItem key={contact.value}>
            <MemberRemove onClick={() => deleteSelectedContact(contact.value)}>
              <RemoveIcon />
            </MemberRemove>
            <MemberCard>
              {contact.label}
            </MemberCard>
            <MemberSwitch>
              <FormControlLabel
                control={
                  <Switch
                    checked={contact?.alert}
                    onChange={(event) => {
                      const { checked } = event.target;
                      alertSelectedContact(contact.value, checked);
                    }}
                    inputProps={{ 'aria-label': 'primary checkbox' }}
                  />
                }
                style={{ margin: '0px' }}
              />
            </MemberSwitch>
          </MemberItem>
        ))}
      </MembersList>
      <ContactWrapper className='mt-5'>
        <AddNewBtn
          onClick={() => {
            formik.setFieldValue("addNewContact", !formik.values?.addNewContact);
          }}>
          +
          <span>Add New</span>
        </AddNewBtn>
      </ContactWrapper>
      {formik.values?.addNewContact && (

        <ContactField className="">
          <LabelField
            title={"Contact"}
            style={{
              fontSize: "12px",
            }}
            mandatory={true}
          />
          <Selection
            name="eventType"
            mandatory={true}
            placeholder="Select Contact"
            options={contactsList}
            isLoading={contactsLoading}
            style={"secondary"}
            onChange={contactSelectedHandler}
            value={formik.values?.selectedContact}
          />
        </ContactField>
      )}

    </AddGroupMembersContainer>
  )
}

export default AddGroupMembers